// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-wrapper ul.notification-list li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul.notification-list li .badge-count {
  bottom: 15px !important;
  padding: 1px 7px !important;
}
.list-wrapper ul.notification-list li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul.notification-list li.active .list-active, .list-wrapper ul.notification-list li.active .text-clr-grey {
  color: var(--listcolor) !important;
}
.list-wrapper ul.notification-list li:hover {
  background: var(--listbackgoundhover) !important;
}

.se-p.is-notification .menu-options.level, .se-p.is-chat .menu-options.level {
  padding: 24px 11px 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notification/notification.component.scss"],"names":[],"mappings":"AAEQ;EAEI,2CAAA;AAFZ;AAGW;EACC,uBAAA;EACA,2BAAA;AADZ;AAKO;EACE,gDAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;AAHT;AAKS;EACG,kCAAA;AAHZ;AASO;EACI,gDAAA;AAPX;;AAWA;EACI,uBAAA;AARJ","sourcesContent":[".list-wrapper{\n    ul.notification-list {\n        li{\n           \n            color: var(--textsecondarycolor) !important;\n           .badge-count{\n            bottom: 15px !important;\n            padding: 1px 7px !important;\n           }            \n        }\n       \n       li.active{\n         background:var(--listbackgoundhover) !important;\n         color:var(--listcolor) !important;\n         border-top:1px solid #4bf768;\n         border-bottom: 1px solid #4bf768;\n        \n         .list-active,.text-clr-grey{\n            color:var(--listcolor) !important;\n         }\n         \n\n       }\n\n       li:hover{\n           background:var(--listbackgoundhover) !important;\n       }\n    }\n}\n.se-p.is-notification .menu-options.level, .se-p.is-chat .menu-options.level {\n    padding: 24px 11px 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
